import { render, staticRenderFns } from "./PregledPodsetnikaPoPrimaocima.vue?vue&type=template&id=d92c7ad8&"
import script from "./PregledPodsetnikaPoPrimaocima.vue?vue&type=script&lang=ts&"
export * from "./PregledPodsetnikaPoPrimaocima.vue?vue&type=script&lang=ts&"
import style0 from "./PregledPodsetnikaPoPrimaocima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports